import {Component, EventEmitter, OnDestroy, Output} from '@angular/core';
import {IButton, IButtonData} from '../../dropdown/IButton';
import {ButtonClass} from '../../dropdown/Button.class';
import {Button} from '../models/button.model';
import {ButtonDividerClass} from '../../dropdown/ButtonDivider.class';
import {CurrentDirectoryFilesService} from '../../services/currentDirectoryFiles.service';
import {combineLatest, Subscription} from 'rxjs';
import {FileManagerConfiguration} from '../../configuration/fileManagerConfiguration.service';
import {IToolbarEvent} from '../interface/IToolbarEvent';
import {ToolbarEventModel} from '../models/toolbarEvent.model';
import {distinctUntilChanged} from 'rxjs/operators';

@Component({
    standalone: false,
  selector: 'ri-selection-dropdown',
  templateUrl: './selection.dropdown.html'
})
export class SelectionComponent implements OnDestroy {
  @Output()
  public onMenuButtonClick = new EventEmitter();

  public selectButtonsList: IButton[];

  public selectAllButton = new ButtonClass({
    symbol: Button.SELECT_ALL,
    name: 'RI_FM_LBL_SELECT_ALL',
    label: true,
    icon: true,
    iconCssClass: 'fa fa-check-square-o'
  });

  public unselectAllButton = new ButtonClass({
    symbol: Button.UNSELECT_ALL,
    name: 'RI_FM_LBL_UNSELECT_ALL',
    label: true,
    icon: true,
    iconCssClass: 'fa fa-square-o'
  });

  public inverseSelectionButton = new ButtonClass({
    symbol: Button.INVERSE_SELECTION,
    name: 'RI_FM_LBL_INVERSE_SELECTION',
    label: true,
    icon: true,
    iconCssClass: 'fa fa-check-square'
  });

  public deleteSelectionButton = new ButtonClass({
    symbol: Button.DELETE_SELECTION,
    name: 'RI_FM_LBL_DELETE_SELECTION',
    label: true,
    icon: true,
    iconCssClass: 'fa fa-trash'
  });

  public chooseSelectionButton = new ButtonClass({
    symbol: Button.CHOOSE_SELECTION,
    name: 'RI_FM_LBL_CHOOSE_SELECTION',
    label: true,
    icon: true,
    iconCssClass: 'fa fa-image'
  });

  public onLoadFilesSubscriber: Subscription;

  public constructor(public configuration: FileManagerConfiguration,
                     public currentDirectoryFilesService: CurrentDirectoryFilesService) {

    this.selectButtonsList = this.createBasicButtons();

    this.initListenOnLoadFiles();
  }

  public ngOnDestroy() {
    this.onLoadFilesSubscriber.unsubscribe();
  }

  /**
   * Initialize listener on load files
   */
  public initListenOnLoadFiles() {
    this.onLoadFilesSubscriber = combineLatest(
      this.currentDirectoryFilesService.currentDirectoryFileIds$,
      this.currentDirectoryFilesService.selectedFiles$
    )
      .pipe(
        distinctUntilChanged()
      )
      .subscribe((data: string[][]) => {
        const numberOfFiles = data[0].length;
        const numberOfSelectedFiles = data[1].length;

        this.disableAllButtons();

        if (numberOfFiles > 0) {
          if (numberOfSelectedFiles > 0) {
            this.enableAllButtons();
          } else {
            this.enableSelectAllButton();
          }
        }
      });
  }


  public onSelectDropdownClick(button: IButtonData) {
    const event: IToolbarEvent = new ToolbarEventModel(button.symbol);
    this.onMenuButtonClick.emit(event);
  }

  /**
   * Disable all dropdown buttons and main button
   */
  public disableAllButtons(): void {
    this.selectAllButton.disabled = true;

    this.selectButtonsList
      .filter((button: IButton) => {
        return !button.isDivider();
      })
      .forEach((button: IButtonData) => {
        button.disabled = true;
      });
  }

  /**
   * Enable all dropdown buttons and main button
   */
  public enableAllButtons(): void {
    this.selectAllButton.disabled = false;

    this.selectButtonsList
      .forEach((button: IButtonData) => {
        button.disabled = false;
      });
  }

  /**
   * Create list of buttons
   */
  public createBasicButtons(): IButton[] {
    const buttons = [
      this.selectAllButton,
      this.unselectAllButton,
      this.inverseSelectionButton,
      new ButtonDividerClass(),
      this.deleteSelectionButton,
    ];

    if (this.configuration.allowChooseMultipleFiles) {
      buttons.push(new ButtonDividerClass());
      buttons.push(this.chooseSelectionButton);
    }

    return buttons;
  }

  /**
   * Enable only select button
   */
  public enableSelectAllButton(): void {
    this.selectAllButton.disabled = false;
    this.inverseSelectionButton.disabled = false;
  }
}
